import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface SalesforceAuthState {
    token: string | null;
}

const initialState: SalesforceAuthState = {
    token: null
};

const salesforceAuthSlice = createSlice({
    name: "salesforceAuth",
    initialState,
    reducers: {
        setSalesforceToken: (state, action: PayloadAction<string>) => {
            state.token = action.payload;
        },
        clearSalesforceToken: (state) => {
            state.token = null;
        }
    }
});

export const { setSalesforceToken, clearSalesforceToken } =
    salesforceAuthSlice.actions;

export default salesforceAuthSlice.reducer;
